<div class="input-group mr-2">
    <input class="form-control" (blur)="inputBlur($event)" [ngModel]="dateString | date:inputDatetimeFormat" (change)="onInputChange($event)" [readonly]='timedisabled' />

    <div class="input-group-append">
        <button class="btn btn-outline-secondary" [ngbPopover]="calendarContent" [disabled]='disabled' type="button">
            <i class="fa fa-calendar-alt"></i>
        </button>
    </div>
</div>




<ng-template #calendarContent>
    <div >
        <div *ngIf="!showTimePickerToggle" >
            <ngb-datepicker #dp  name="datepicker" [ngModel]="datetime"  (ngModelChange)="onDateChange($event)"></ngb-datepicker>
            <button class="btn btn-block btn-outline-secondary" [disabled]="!datetime?.day" [ngbPopover]="timePickerContent" type="button" (click)="toggleDateTimeState($event)">
                <i class="fa fa-clock"></i>
            </button>
        </div>
        <div *ngIf="showTimePickerToggle" >
                <button class="btn btn-block btn-outline-secondary" [ngbPopover]="calendarContent" type="button" (click)="toggleDateTimeState($event)">
                    <i class="fa fa-calendar-alt"></i>
                </button>
            <div class="mt-auto">
            <ngb-timepicker meridian="true" #tp name="timepicker" [ngModel]="datetime" (ngModelChange)="onTimeChange($event)" 
            [hourStep]="hourStep" [minuteStep]="minuteStep"></ngb-timepicker>
            </div>
        </div>
    </div>
</ng-template>

